import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';
import Modal from '@spa/shared/components/Modal';
import RadioButton from '@spa/shared/components/Unisystem/RadioButton';
import { reportListing } from '@spa/shared/clients/reportListing';
import Button from '@spa/shared/components/Unisystem/Button';
import { Form, Buttons, Separator } from './styles';
import { connect } from 'react-redux';
import { trackReportListingSubmit } from '@spa/offer/store/actions/tracking';
var REPORT_LISTING_REASONS = {
  poor_quality_photos: 'Poor quality photos',
  information_is_not_consistent: 'Information is not consistent',
  content_is_offensive: 'Content is offensive',
  looks_like_a_scam: 'Looks like a scam',
  // eslint-disable-next-line quotes
  dont_like_this_listing: "I don't like this listing"
};
var ReportListing = function ReportListing(_ref) {
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    offerId = _ref.offerId,
    trackReportListingSubmitAction = _ref.trackReportListingSubmitAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    selectedReason = _useState[0],
    setSelectedReason = _useState[1];
  var sendReport = useCallback(function () {
    trackReportListingSubmitAction(selectedReason, offerId);
    reportListing(selectedReason, offerId, null, new Date().toString())["finally"](onClose);
  }, [selectedReason]);
  return (
    // eslint-disable-next-line quotes
    __jsx(Modal, {
      onClose: onClose,
      title: t("What's wrong with this listing?")
    }, __jsx(Form, null, Object.entries(REPORT_LISTING_REASONS).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        value = _ref3[0],
        label = _ref3[1];
      return __jsx(RadioButton, {
        name: 'report-listing',
        key: value,
        value: value,
        label: t(label),
        isChecked: value === selectedReason,
        onChange: function onChange() {
          return setSelectedReason(value);
        }
      });
    })), __jsx(Separator, null), __jsx(Buttons, null, __jsx(Button, {
      isPrimary: true,
      onClick: sendReport,
      isDisabled: !selectedReason
    }, t('Report listing')), __jsx(Button, {
      isSecondary: true,
      onClick: onClose
    }, t('Cancel'))))
  );
};
var mapStateToProps = function mapStateToProps(_ref4) {
  var offerId = _ref4.offer.offerAggregate.accommodation_offer.id;
  return {
    offerId: offerId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackReportListingSubmitAction: function trackReportListingSubmitAction(reason, offerId) {
      return dispatch(trackReportListingSubmit({
        reason: reason,
        offerId: offerId
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportListing);